import Vue from 'vue'

export default {
  saveBanner(affiliateUserId, payload) {
    return Vue.axios.post(`/api/v1/affiliate/${affiliateUserId}/banner`, payload)
  },
  fetchBanners(affiliateUserId, page = 1) {
    return Vue.axios.get(`/api/v1/affiliate/${affiliateUserId}/banner/?page=${page}`).then(response => response.data)
  },
  fetchBannerHTML(affiliateUserId, bannerId, size) {
    return Vue.axios.get(`/api/v1/affiliate/${affiliateUserId}/banner/${bannerId}/html?size=${size}`).then(response => response.data)
  },
  deleteBanner (affiliateUserId, referralCode) {
    return Vue.axios.delete(`/api/v1/affiliate/${affiliateUserId}/banner/${referralCode}`).then(response => response.data)
  },
}